import { foundationSliderLabelStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
export const zeroSliderLabelStyles = (context, definition) => css `
  ${foundationSliderLabelStyles(context, definition)}
  .label {
    padding: 6px 8px;
    border-radius: calc(var(--control-corner-radius) * 1px);
    border: calc(var(--stroke-width) * 1px) solid #2e3339;
    background-color: #c9c9c9;
    color: #161616;
    text-align: center;
    font-size: var(--type-ramp-minus-1-font-size, 12px);
  }
`;
